import React, { useState } from 'react';
import { checkOriginNonProd, isWebMobile, openCloseScanner } from '../../utils/util';
import ScannerWebUI from './ScannerWebUI';

const ScannerCode = (props) => {
    const [openScanWeb, setOpenScanWeb] = useState(false);

    const closeScanner = () => {
        const nameEvent = props?.id || 'message';
        document.removeEventListener(nameEvent, msgHandler);
        openCloseScanner('close');
    };

    const openScanner = () => {
        if (props.disabledValidate && props.disabledValidate()) {
            return;
        }

        if (navigator.userAgent === 'logisticspwa') {
            const nameEvent = props?.id || 'message';
            window.onMessageMobile = function (e) {
                const value = e.data;
                if (props.onScanner) {
                    return props.onScanner(value.length >= 3 ? value : undefined);
                }
            };
            document.addEventListener(nameEvent, msgHandler);
            openCloseScanner('open', props.markerCodeBar, props.sizeCode);
        } else if (isMobile()) {
            setOpenScanWeb(true);
        }
    };

    const msgHandler = (e) => {
        closeScanner();
        const value = e.data;
        if (props.onScanner) {
            return props.onScanner(value.length >= 3 ? value : undefined);
        }
    };

    const isMobile = () => {
        return (isWebMobile() || (navigator.userAgent !== 'logisticspwa' && checkOriginNonProd(window)))
    }

    return (
        <>
            <i className={props.className ? props.className : 'mdi mdi-barcode-scan posfix'} style={{ top: '0rem', cursor: 'pointer' }} onClick={openScanner} />
            {/* {
                isMobile()
                && openScanWeb
                && <ScannerWebUI onClose={() => setOpenScanWeb(false)} {...props} />
            } */}
        </>
    );
};

export default ScannerCode;
